'use strict';

function UpcomingEvents() {
  $('.paragraph--type--upcoming-events article').matchHeight();
};
export default UpcomingEvents;
